import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { ImageVideoSlider } from "components/common";
import { useState } from "react";
import ViewImageDetailModal from "./viewImageDetailModal";

const ExplanationMediaAndActions = ({ explanation }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const allMedia = [
    ...explanation?.media,
    ...(explanation?.LicensedImage?.length
      ? explanation?.LicensedImage?.map((e) => ({ ...e, type: "licenseImage" }))
      : []),
    // ...(explanation?.YTIframe?.length
    //   ? explanation?.YTIframe?.map((e) => ({ ...e, type: "licenseVideo" }))
    //   : []),
    ...(explanation?.LicensedPodcast?.length
      ? explanation?.LicensedPodcast?.map((e) => ({
          ...e,
          type: "licensePodcast",
        }))
      : []),
  ];

  const renderPreviewMask = (item, index) => {
    return (
      <div className="custom-preview-mask">
        <div
          className="preview-action"
          onClick={() => setSelectedItem({ item: item, type: "preivew" })}
        >
          <EyeOutlined />
          <span className="action-text">Preview</span>
        </div>
        {/* refernce if we need to add edit and delete */}
        {/* <div
          className="preview-action"
          onClick={() => setSelectedItem({ item: item, type: "edit" })}
        >
          <EditOutlined />
          <span className="action-text">Edit</span>
        </div>
        <div
          className="preview-action"
          onClick={() => handleDelete(item, index)}
        >
          <DeleteOutlined />
          <span className="action-text">Delete</span>
        </div> */}
      </div>
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      {explanation?.LicensedImage?.length ? (
        <ImageVideoSlider
          dataList={allMedia?.map((img) => ({
            ...img,
            src: img?.ImageURL,
            alt: img?.ImageURL,
          }))}
          width={200}
          height={125}
          renderPreviewMask={renderPreviewMask}
        />
      ) : null}

      {explanation?.YTIframe?.length ? (
        <ImageVideoSlider
          dataList={explanation?.YTIframe?.map((img) => ({
            ...img,
            src: img?.ImageURL,
            alt: img?.ImageURL,
            type: "licenseVideo",
          }))}
          width={200}
          height={200}
          renderPreviewMask={renderPreviewMask}
        />
      ) : null}
      <ViewImageDetailModal
        selectedItem={
          selectedItem?.type === "preivew" ? selectedItem?.item : null
        }
        setSelectedItem={setSelectedItem}
      />
    </div>
  );
};

export default ExplanationMediaAndActions;
